module.exports = __webpack_public_path__ + "static/media/baleine3.ff5ab349.jpg";